window.onload = function () {

	var _lastKnownScrollPosition;

	Hamburger();

	let pageFunctions = {

		CheckHeaderPosition: function (windowScrollPosition) {

			var header = document.querySelector('header');
			var largeLogo = document.querySelector('er-logo');
			var smallLogo = document.querySelector('er-logo-small');
			var nav = document.querySelector("#main-navigation");
			var navPos = nav.getBoundingClientRect();

			// console.log("Nav position: %O", navPos);

			if (navPos.top <= 0) {
				smallLogo.classList.remove("hidden");
			}
			else {
				smallLogo.classList.add("hidden");
			}

		}

	}

	pageFunctions.CheckHeaderPosition();

	window.addEventListener('scroll', function () {

		_lastKnownScrollPosition = window.scrollY;

		pageFunctions.CheckHeaderPosition(_lastKnownScrollPosition);

	})

}